import gql from 'graphql-tag'

import { PublicExpoEventBySlugQuery } from '../../../types/api'

export const eventBySlug = {
  query: gql`
    query publicExpoEventBySlug($slug: String!) {
      publicExpoEventBySlug(slug: $slug) {
        uuid
        slug
        name
        description
        frontTitle
        frontDescription
        frontImage
        registration_closing_at
        locales {
          id
          label
          iso
        }
        slots {
          id
          bookable
          opening_hour
          closing_hour
          remaining_capacity
          event {
            id
            uuid
            name
            slug
          }
        }
      }
    }
  `,
  transformer: (response: PublicExpoEventBySlugQuery) => {
    return response.publicExpoEventBySlug
  },
}
